module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "m-footer-layout-comment",
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "click": _vm.hide
    }
  }, [_c('sq-comment')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4d55ab1c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/commentArea.vue
// module id = 205
// module chunks = 1